import React, { useEffect, useRef, useState } from "react";
import { MdOndemandVideo } from "react-icons/md";
import ReactPlayer from "react-player";
import endpoints from "../../utility/endpoints";
import { CustomVideo } from "../shared/PlayIcon";
import { RxCross2 } from "react-icons/rx";

const CreateBotTutorial = () => {
  const messageText = "Click here to know about new updates";
  const [message, setMessage] = useState("");
  const [index, setIndex] = useState(0);
  const videoUrl =
    "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/instructionvideos/Create_bot_et.mp4?" +
    process.env.NEXT_PUBLIC_SAS_TOKEN;

  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef();

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage(messageText.slice(0, index + 1));
      setIndex((prev) => {
        if (prev === messageText.length) return 0; // restart
        return prev + 1;
      });
    }, 200); // typing speed

    return () => clearInterval(interval);
  }, [index]);

  useEffect(() => {
    if (showVideo) {
      videoRef.current?.play();
    } else {
      videoRef.current?.pause();
    }
  }, [showVideo]);

  const closeVideo = (e) => {
    e.stopPropagation();
    setShowVideo(false);
  };

  return (
    <>
      <div className="absolute right-2 top-2 text-primary flex items-center gap-2 cursor-default">
        {message}
        <MdOndemandVideo
          onClick={() => setShowVideo(true)}
          className="!w-8 !h-8 cursor-pointer animate-pulse"
        />
      </div>
      {showVideo && (
        <div className="z-[9999] fixed left-0 top-0 w-screen h-screen bg-[rgba(0,0,0,0.2)] flex justify-center items-center">
          <div className="h-[85%] relative">
            <div
              onClick={closeVideo}
              className="w-8 h-8 flex justify-center items-center bg-red-500 absolute z-[99999] right-0 top-0 !cursor-pointer"
            >
              <RxCross2 className="text-white w-5 h-5" />
            </div>
            <CustomVideo
              ref={videoRef}
              src={videoUrl}
              controls
              className="!w-full !h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CreateBotTutorial;

